<template>
  <div class="countdown" ref="countDown" :style="style"></div>
</template>
<script>
  import CountDown from './src/countdown';

  export default {
    name: 'CountDown',
    props: {
      target: {
        type: String,
        default: '2019-08-05 23:59:59'
      },
      width: {
        type: [Number, String],
        default: '54px'
      },
      height: {
        type: [Number, String],
        default: '70px'
      },
      size: {
        type: [Number, String],
        default: 60
      },

      days: {
        type: Boolean,
        default: false
      },
      hours: {
        type: Boolean,
        default: true
      },
      minutes: {
        type: Boolean,
        default: true
      },
      seconds: {
        type: Boolean,
        default: true
      },

      numberPics: {
        type: Array,
        default() {
          return [];
        }
      },

      interval: {
        type: Number,
        default: 1000
      },
      helperClass: {
        type: String,
        default: 'help'
      }
    },
    computed: {
      style() {
        return {
          height: Number(this.height).toString() === "NaN" ? this.height : this.height + 'px',
          fontSize: Number(this.size).toString() === "NaN" ? this.size : this.size + 'px'
        }
      }
    },
    mounted() {
      const width = Number(this.width).toString() === "NaN" ? this.width : this.width + 'px';

      this.countDown = new CountDown(this.$refs.countDown, {
        target: this.target,
        width: width,
        days: this.days,
        hours: this.hours,
        minutes: this.minutes,
        seconds: this.seconds,
        numberPics: this.numberPics,
        helperClass: this.helperClass,
        interval: this.interval,
      });

      if (this.countDown && this.countDown._on) {
        this.countDown._on('end', () => {
          this.$emit('end');
        });
        this.countDown._on('change', () => {
          this.$emit('change');
        });
      }
    },
    methods: {
      pause() {
        this.countDown.pause();
      },
      start() {
        this.countDown.start();
      }
    }
  }
</script>
<style type="text/css">
  @import "./css/index.css";
</style>



// WEBPACK FOOTER //
// src/n_modules/mini-countdown/components/countdown.vue